import { render, staticRenderFns } from "./DashboardNivelTensaoVisaoComparativo.vue?vue&type=template&id=70186abe&"
import script from "./DashboardNivelTensaoVisaoComparativo.vue?vue&type=script&lang=js&"
export * from "./DashboardNivelTensaoVisaoComparativo.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNivelTensaoVisaoComparativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VCard,VCardText,VCol,VDataTable,VRow,VSelect,VSimpleTable})
